<div
  class="modal-overlay"
  [class.active]="isActive"
  (click)="onBackdropClick()">
  <div class="modal confirmation-dialog" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="close-modal"
      (click)="onCancel()"
      aria-label="Close dialog">
      x
    </button>

    <div class="dialog-content">
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
    </div>

    <div class="dialog-actions">
      <button
        *ngIf="showCancelButton"
        type="button"
        class="cancel-btn"
        (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="confirm-btn"
        [class.destructive]="destructive"
        (click)="onConfirm()">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
